// components/leads/LeadStatsCards.js
// Card statistiche per filtro rapido

import React from 'react';
import { Card, CardContent } from '../ui/card';
import { User, FileText, CheckCircle, XCircle } from 'lucide-react';

const LeadStatsCards = ({ stats, statusFilter, setStatusFilter }) => {
  const cards = [
    {
      key: 'all',
      label: 'Totali',
      value: stats.total,
      icon: User,
      bgColor: 'bg-gray-100',
      iconColor: 'text-gray-600',
      textColor: 'text-[#3C3C3C]',
      ringColor: 'ring-gray-400',
      tooltip: 'Tutti i lead'
    },
    {
      key: 'attivi',
      label: 'Preventivi',
      value: stats.attivi,
      icon: FileText,
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-600',
      textColor: 'text-blue-600',
      ringColor: 'ring-blue-500',
      tooltip: 'Lead con preventivi in lavorazione'
    },
    {
      key: 'convertito',
      label: 'Convertiti',
      value: stats.convertiti,
      icon: CheckCircle,
      bgColor: 'bg-green-100',
      iconColor: 'text-green-600',
      textColor: 'text-green-600',
      ringColor: 'ring-green-500',
      tooltip: 'Lead convertiti in progetto'
    },
    {
      key: 'perso',
      label: 'Persi',
      value: stats.persi,
      icon: XCircle,
      bgColor: 'bg-red-100',
      iconColor: 'text-red-600',
      textColor: 'text-red-600',
      ringColor: 'ring-red-500',
      tooltip: 'Lead persi'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map(card => {
        const Icon = card.icon;
        const isSelected = statusFilter === card.key || 
          (card.key === 'attivi' && statusFilter === 'attivi');
        
        return (
          <Card 
            key={card.key}
            className={`card-abitalo cursor-pointer transition-all duration-200 hover:shadow-lg hover:scale-[1.02] ${
              isSelected ? `ring-2 ${card.ringColor} shadow-lg` : ''
            }`}
            onClick={() => setStatusFilter(statusFilter === card.key ? 'all' : card.key)}
            title={card.tooltip}
            data-testid={`filter-${card.key}`}
          >
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs text-[#737373] uppercase tracking-wide">{card.label}</p>
                  <p className={`text-2xl font-bold ${card.textColor}`}>{card.value}</p>
                </div>
                <div className={`w-10 h-10 ${card.bgColor} rounded-full flex items-center justify-center`}>
                  <Icon className={`w-5 h-5 ${card.iconColor}`} />
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default LeadStatsCards;
